$(document).ready(function () {
  $(".toggle-search-bar-filters").on("click", function() {
    $(".search-bar-filters").toggleClass("search-bar-filters-visible");
    $(".toggle-search-bar-filters").toggleClass("show");
  });
});
